import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Button } from './ui/button';
import { getUserLists } from '../data/mock';

const FloatingActions = () => {
  const [totalWalks, setTotalWalks] = useState(0);

  // Update total walks count when component mounts and when localStorage changes
  useEffect(() => {
    const updateTotalCount = () => {
      const lists = getUserLists();
      const total = Object.values(lists).reduce((acc, list) => acc + list.walks.length, 0);
      setTotalWalks(total);
    };

    // Initial count
    updateTotalCount();

    // Listen for storage changes (when lists are updated)
    const handleStorageChange = (e) => {
      if (e.key === 'wanderloopLists') {
        updateTotalCount();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events when lists change within the same tab
    const handleListChange = () => {
      updateTotalCount();
    };
    
    window.addEventListener('listToggled', handleListChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('listToggled', handleListChange);
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3" style={{ zIndex: 9999 }}>
      {/* Submit Walk Button */}
      <Link to="/submit">
        <div className="group relative">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #F5A623, #E8622A)' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </div>
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2">
            <div className="bg-black/80 text-white text-xs px-2.5 py-1 rounded-lg whitespace-nowrap shadow">
              Submit a Walk
            </div>
          </div>
        </div>
      </Link>

      {/* Favorites Button */}
      <Link to="/favorites">
        <div className="group relative">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer relative"
            style={{ background: 'linear-gradient(135deg, #F5A623, #E8622A)' }}
          >
            <Heart className="h-6 w-6 text-white fill-current" />
            {totalWalks > 0 && (
              <div className="absolute -top-2 -right-2 bg-yellow-500 text-white text-xs rounded-full h-6 w-6 flex items-center justify-center font-bold">
                {totalWalks > 99 ? '99+' : totalWalks}
              </div>
            )}
          </div>
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2">
            <div className="bg-black/80 text-white text-xs px-2.5 py-1 rounded-lg whitespace-nowrap shadow">
              My Lists{totalWalks > 0 ? ` (${totalWalks})` : ''}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FloatingActions;